'use client';

import Modal from './modal'

import Spinner from './spinner';

function Loader({ className = "", spinnerClass = "", isOpen = true }) {
  return (
    <Modal
      isOpen={isOpen}
      className={`z-50 ${className}`}
    >
      <Spinner className={spinnerClass} />
    </Modal>
  )
}

export default Loader